import idx from 'idx';

/**
 * Resolves the project type based on availability and fallback rules.
 * 
 * Logic order:
 * 1. Provided projectType (e.g. from URL search params or project data)
 * 2. Currently active project type from Redux state (state.project.projectType)
 * 3. First allowed project module from user's permissions (state.project.allowedModules[0])
 * 4. Default to 'MAJOR'
 * 
 * @param {string} projectType - The primary project type candidate
 * @param {Object} projectState - The 'project' slice from Redux state (contains projectType, allowedModules)
 * @returns {string} - The resolved project type
 */
export const resolveProjectType = (projectType, projectState) => {
    if (projectType) return projectType;

    // 1. Get active projectMenu type from state
    const activeType = idx(projectState, _ => _.projectType);
    if (activeType) return activeType;

    // 2. Get the first project submenu type the user has permission for
    const allowedModules = idx(projectState, _ => _.allowedModules) || [];
    if (allowedModules.length > 0) {
        return allowedModules[0];
    }

    // Fallback constant
    return 'MAJOR';
};
